export const normalizeContentfulIndustryNodes = (allContent) => {

  const content = allContent[0]

  return {
    hero: {
      text: [
          {
            "text": content.title,
            "color": "omegaDarker",
            "variant": "h1"
          },
          {
            "text": content.subtitle,
            "color": "omegaDark",
            "variant": "medium"
          }
        ],
        images: [
          {
            src: content.hero,
            "alt": "alt text",
            "radius": "lg",
            "shadow": "xl",
            "effects": ["fadeInLeft"]
          }
        ],
        "buttons": [
          {
            "text": "Get Started",
            "type": "PAGE",
            "link": "https://sheetgurus.com/account/signup?referrer=website_industry",
            "variant": "primary"
          }
        ]
      },
      contentOne: {
        "collection": [
          {
            "text": [
              {
                "text": content.secondaryTitle,
                "color": "alpha",
                "variant": "h4"
              },
              {
                "text": content.secondarySubtitle,
                "color": "omegaDarker",
                "variant": "h3"
              }
            ]
          },
          {
            "text": [
              {
                "text": content.secondaryContentOne.secondaryContentOne,
                "color": "omegaDark",
                "variant": "p"
              },
              {
                "text": content.secondaryContentTwo.secondaryContentTwo,
                "color": "omegaDark"
              }
            ]
          }
        ]
      },
      contentTwo: {
        "collection": [
          {
            "text": [
              {
                "text": content.tertiaryTitle,
                "color": "alphaLight",
                "variant": "h4"
              },
              {
                "text": content.tertiarySubtitle,
                "color": "white",
                "variant": "h3"
              }
            ],
            "buttons": [
              {
                "text": "Get Started",
                "type": "PAGE",
                "link": "https://sheetgurus.com/account/signup?referrer=website",
                "variant": "secondary"
              }
            ]
          },
          {
            "text": [
              {
                "text": content.tertiaryContentOne.tertiaryContentOne,
                "color": "white",
                "variant": "p"
              },
              {
                "text": content.tertiaryContentTwo.tertiaryContentTwo,
                "color": "white"
              }
            ]
          }
        ]
      },

      }
    }
